import { Component, OnInit } from '@angular/core';
import { DashboardService } from 'app/services/dashboard.service';
import { ExcelService } from '../../../services/excel.service';
import { ShiftDataService } from '../shift-data.service';
import { DatePipe } from '@angular/common';
import { MatDialogRef } from '@angular/material/dialog';
import { AlertService } from 'app/shared/alert/alert.service';
import { ActivatedRoute, NavigationExtras, Router } from '@angular/router';
import { Location } from '@angular/common';

@Component({
    selector: 'app-download-report-dialog',
    templateUrl: './download-report-dialog.component.html',
    styleUrls: ['./download-report-dialog.component.scss'],
})
export class DownloadReportDialogComponent implements OnInit {
    location: any;
    isMaster = false;
    disableDownloadButtonsForWO:boolean = false;
    /* to display the info instead of downloads option,if either date selected older then 3 month from current month or date not selected -next 3 lines */
    displayWarningMsg : boolean = false;
    period_from: any = '';
    period_to: any = '';
    estimatedTime:any;
    weeklyReportsData : any[]=[];
    dataAlreadyPresent:boolean = false;
    montlyReportsData : any[]= [];
    excelDownload:boolean = false;
    pdfDownload:boolean = false;

    constructor(
        private shiftDataService: ShiftDataService,
        private excelService: ExcelService,
        public dashboardService: DashboardService,
        public datepipe: DatePipe,
        public dialogRef: MatDialogRef<DownloadReportDialogComponent>,
        private alertService: AlertService,
        private router: Router,
        private route: ActivatedRoute,private loc: Location
    ) {}

    ngOnInit(): void {
        let currentPage :any = localStorage.getItem('currentPage');
        /* to display the info instead of downloads option,if either date selected older then 3 month from current month or date not selected */
        this.getCurrentMonthEndDate();
        this.getThirdPreviousMonthStartDate();
        let periodFrom: any = localStorage.getItem("periodFrom");
        let periodTo: any = localStorage.getItem("periodTo");
        let selectedFilter: any = localStorage.getItem("selectedFilter");
        /**when date filter applied out of range(more than 3 months wrt current month) warning msg is shown */
        if(selectedFilter != null && selectedFilter != "" && selectedFilter != undefined && currentPage != 'TrackingModule'){
            selectedFilter = JSON.parse(selectedFilter);
        }
        else if(periodFrom != null && periodFrom != "" && periodFrom != undefined && periodTo != null && periodTo != "" && periodTo != undefined){
            periodTo = this.formatDateToYYYYMMDD(new Date(periodTo));
            periodFrom = this.formatDateToYYYYMMDD(new Date(periodFrom))
        }
        const currentSelectedPage = localStorage.getItem('currentPage');
        this.disableDownloadButtonsForWO = (currentSelectedPage == 'TrackingModule' || currentSelectedPage == 'WorkOrder')? true:false;
        this.location = window.location.pathname;
        this.isMaster = this.location.includes('shift-data') ? false : true;
    }
       
    formatDateToYYYYMMDD(date: Date): string {
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are 0-based
        const day = String(date.getDate()).padStart(2, '0'); // Days are 1-based
        return `${year}-${month}-${day}`;
    }

    /* to display the info instead of downloads option,if either date selected older then 3 month from current month or date not selected */
    getCurrentMonthEndDate(): string {
        const currentDate = new Date();
        const year = currentDate.getFullYear();
        const month = currentDate.getMonth() + 1; // 1-based month
        const endDate = new Date(year, month, 0); // Last day of the current month
        // Format the date as yyyy-mm-dd
        const formattedDate = endDate.toISOString().split('T')[0];
        this.period_to = formattedDate;
        return formattedDate;
    }

    /* to display the info instead of downloads option,if either date selected older then 3 month from current month or date not selected */
    getThirdPreviousMonthStartDate(): string {
        const currentDate = new Date();
        const currentYear = currentDate.getFullYear();
        const currentMonth = currentDate.getMonth(); // 0-based (0 = January)
        // Calculate the 3rd previous month and year
        const thirdPreviousMonth = (currentMonth - 3 + 12) % 12; // Month index (0-11)
        const yearAdjustment = currentMonth - 3 < 0 ? -1 : 0; // Adjust year if crossing into the previous year
        const thirdPreviousYear = currentYear + yearAdjustment;
        // Ensure correct formatting without timezone issues
        const formattedDate = `${thirdPreviousYear}-${String(thirdPreviousMonth + 1).padStart(2, '0')}-01`;
        this.period_from = formattedDate;
        return formattedDate;
    }
    onDownloadExcelClick(){
        this.excelDownload = true;
        this.pdfDownload = false;
        const currentPage = localStorage.getItem('currentPage');
        const selectedFilters = JSON.parse(
            localStorage.getItem('selectedFilter') || '{}'
        );
        const currentDate = new Date().toISOString().slice(0, 10); // Get current date in "YYYY-MM-DD" format
         const currentTime = new Date().toLocaleTimeString('en-US', { hour12: false }); // Get current time in "HH:mm:ss" format
         let date = `${currentDate} ${currentTime}`;
        selectedFilters.site_id =
            this.shiftDataService.selectedMasterSite.sub_sites
                .map((site) => site.site_id)
                .toString();
                selectedFilters.date = date;
        // let site_ids;
        if(selectedFilters.site_id){
        //     site_ids = selectedFilters.site_ids;
            delete selectedFilters.site_id;
        }
        let isNight = this.checkLocalStorage('isNight');
        let isDay = this.checkLocalStorage('isDay');
        let isDayNight = (isDay && isNight) ? 'both' : isNight ? 'Night' : isDay ? 'Day' : '';
        let fileName =
            this.shiftDataService.selectedMasterSite.site_name +
            '-' +
            (this.location.includes('shift-data') ? 'shift' : 'master') +
            '-data' +
            new Date().toDateString();
            this.shiftDataService.isUnique = JSON.parse(localStorage.getItem('isUniqueButton'));
            let isShiftDataShoulder = this.checkLocalStorage("isShiftDataShoulder");
            let isShiftDataMedian = this.checkLocalStorage("isShiftDataMedian");
            let isShoulderMedian = (isShiftDataShoulder && isShiftDataMedian) ? '' : (isShiftDataShoulder) ? 'shoulder' : 'median';
            if(selectedFilters.asset_ids && selectedFilters.asset_ids.length == 0 && selectedFilters.periodFrom != null 
                && selectedFilters.periodTo != null && selectedFilters.site_ids && selectedFilters.site_ids.length == 2){
                    let periodDiff = selectedFilters.periodFrom + '-' + selectedFilters.periodTo;
                    this.getWeeklyReportData(periodDiff);     
                    this.getMonthlyReportData(periodDiff);                 
            }
            else{
                this.dashboardService.getEstimatedTimeDetails(
            this.shiftDataService.isUnique, selectedFilters.asset_ids,selectedFilters.periodFrom,selectedFilters.periodTo,selectedFilters.date,selectedFilters.site_ids)
        .subscribe(
            (res : any) => {
                this.convertSecondsToHMS(res.responseData[0].records.total_time_in_seconds_excel);
            },
            (error) => {
            }
        );
        }
    }
    downloadExcelClick() {
        // let data = this.processExportData();
        // this.excelService.exportAsExcelFile(
        //     data,
        //     this.shiftDataService.selectedMasterSite.site_name +
        //         '-' +
        //         (this.shiftDataService.isLhs ? 'LHS' : 'RHS') +
        //         '-' +
        //         (this.location.includes('shift-data') ? 'shift' : 'master') +
        //         '-data'
        // );

        const currentPage = localStorage.getItem('currentPage');
        const selectedFilters = JSON.parse(
            localStorage.getItem('selectedFilter') || '{}'
        );
        const currentDate = new Date().toISOString().slice(0, 10); // Get current date in "YYYY-MM-DD" format
         const currentTime = new Date().toLocaleTimeString('en-US', { hour12: false }); // Get current time in "HH:mm:ss" format
         let date = `${currentDate} ${currentTime}`;
        selectedFilters.site_id =
            this.shiftDataService.selectedMasterSite.sub_sites
                .map((site) => site.site_id)
                .toString();
                selectedFilters.date = date;
        // let site_ids;
        if(selectedFilters.site_id){
        //     site_ids = selectedFilters.site_ids;
            delete selectedFilters.site_id;
        }
        let isNight = this.checkLocalStorage('isNight');
        let isDay = this.checkLocalStorage('isDay');
        let isDayNight = (isDay && isNight) ? 'both' : isNight ? 'Night' : isDay ? 'Day' : '';
        //MCW and Service Lane in Anomaly Page
        let isShiftServiceLanes = this.checkLocalStorage('isShiftServiceLanes');
        let isShiftMCW = this.checkLocalStorage('isShiftMCW');
        let LaneValue = (isShiftServiceLanes && isShiftMCW) ? 'both' : isShiftServiceLanes ? 'SERVICE_LANE' : isShiftMCW ? 'MCW' : '';
        let fileName =
            this.shiftDataService.selectedMasterSite.site_name +
            '-' +
            (this.location.includes('shift-data') ? 'shift' : 'master') +
            '-data' +
            new Date().toDateString();
            this.shiftDataService.isUnique = JSON.parse(localStorage.getItem('isUniqueButton'));
            let isShiftDataShoulder = this.checkLocalStorage("isShiftDataShoulder");
            let isShiftDataMedian = this.checkLocalStorage("isShiftDataMedian");
            let isShoulderMedian = (isShiftDataShoulder && isShiftDataMedian) ? '' : (isShiftDataShoulder) ? 'shoulder' : 'median';
        if (currentPage == 'ShiftDataAnalysis') {
            this.dashboardService
                .generateShiftDataExcelFile(selectedFilters, fileName,this.shiftDataService.isUnique,isDayNight,isShoulderMedian,LaneValue)
                .subscribe(
                    (res) => {
                        // this.replaceSiteIDBySiteIDS(res,selectedFilters,site_ids);
                    },
                    (error) => {
                        // this.replaceSiteIDBySiteIDS(error,selectedFilters,site_ids);
                    }
                );
        }else if (currentPage == 'MasterDataLibrary') {
            this.dashboardService
                .generateMasterExcelFile(selectedFilters, fileName)
                .subscribe(
                    (res) => {
                        // this.replaceSiteIDBySiteIDS(res,selectedFilters,site_ids);
                    },
                    (error) => {
                        // this.replaceSiteIDBySiteIDS(error,selectedFilters,site_ids);
                    }
                );
        }
        else if (currentPage == 'WorkOrder') {
            selectedFilters.anomaly_type = localStorage.getItem('currentWorkOrderTab');
            this.dashboardService
                .generateWorkOrderExcelFile(selectedFilters, fileName,isDayNight)
                .subscribe(
                    (res) => {
                        // this.replaceSiteIDBySiteIDS(res,selectedFilters,site_ids);
                    },
                    (error) => {
                        // this.replaceSiteIDBySiteIDS(error,selectedFilters,site_ids);
                    }
                );
        }
        else if (currentPage == 'TrackingModule') {
            let site_ids :any[]= [];
            let masterSite = JSON.parse(localStorage.getItem('SelectedMasterSite'));
            for(let i = 0;i<masterSite.sub_sites.length;i++) { 
                site_ids.push(masterSite.sub_sites[i].site_id);
            }
            selectedFilters.anomaly_type = localStorage.getItem('currentWorkOrderTab');

            const dateString = localStorage.getItem('periodFrom');
            const date = new Date(dateString);

            // Get the year, month, and day directly from the Date object
            const year = date.getFullYear();
            const month = String(date.getMonth() + 1).padStart(2, '0'); // getMonth() returns 0-based month
            const day = String(date.getDate()).padStart(2, '0');

            // Combine them into the desired format
            const formattedDatePeriodFrom = `${year}-${month}-${day}`;


            const dateString1 = localStorage.getItem('periodTo');
            const date1 = new Date(dateString1);

            // Get the year, month, and day directly from the Date object
            const year1 = date1.getFullYear();
            const month1 = String(date1.getMonth() + 1).padStart(2, '0'); // getMonth() returns 0-based month
            const day1 = String(date1.getDate()).padStart(2, '0');

            // Combine them into the desired format
            const formattedDatePeriodTo = `${year1}-${month1}-${day1}`;

            this.dashboardService
                .generateTrackingModuleExcelFile(site_ids, formattedDatePeriodFrom,formattedDatePeriodTo,selectedFilters.date)
                .subscribe(
                    (res) => {
                        // this.replaceSiteIDBySiteIDS(res,selectedFilters,site_ids);
                    },
                    (error) => {
                        // this.replaceSiteIDBySiteIDS(error,selectedFilters,site_ids);
                    }
                );
        }
    }

    checkLocalStorage(value:string)
    {
        if(localStorage.getItem(value) !== null){
            return localStorage.getItem(value) === "true" ? true : false;
        }
        return true;
    }


    onDownloadPdfClick(){
        this.excelDownload = false ;
        this.pdfDownload = true;
        const currentPage = localStorage.getItem('currentPage');
        const selectedFilters = JSON.parse(
            localStorage.getItem('selectedFilter') || '{}'
        );
        let isNight = this.checkLocalStorage('isNight');
        let isDay = this.checkLocalStorage('isDay');
        let isDayNight = (isDay && isNight) ? 'both' : isNight ? 'Night' : isDay ? 'Day' : '';
        const currentDate = new Date().toISOString().slice(0, 10); // Get current date in "YYYY-MM-DD" format
         const currentTime = new Date().toLocaleTimeString('en-US', { hour12: false }); // Get current time in "HH:mm:ss" format
         let date = `${currentDate} ${currentTime}`;
        selectedFilters.site_id =
            this.shiftDataService.selectedMasterSite.sub_sites
                .map((site) => site.site_id)
                .toString();
                selectedFilters.date = date;
                 // let site_ids;
        if(selectedFilters.site_id){
            //     site_ids = selectedFilters.site_ids;
                delete selectedFilters.site_id;
            }
        let fileName =
            this.shiftDataService.selectedMasterSite.site_name +
            '-' +
            (this.shiftDataService.isLhs ? 'LHS' : 'RHS') +
            '-' +
            (this.location.includes('shift-data') ? 'shift' : 'master') +
            '-data';
            this.shiftDataService.isUnique = JSON.parse(localStorage.getItem('isUniqueButton'));
            let isShiftDataShoulder = this.checkLocalStorage("isShiftDataShoulder");
            let isShiftDataMedian = this.checkLocalStorage("isShiftDataMedian");
            let isShoulderMedian = (isShiftDataShoulder && isShiftDataMedian) ? '' : (isShiftDataShoulder) ? 'shoulder' : 'median';
        this.dashboardService.getEstimatedTimeDetails(
            this.shiftDataService.isUnique, selectedFilters.asset_ids,selectedFilters.periodFrom,selectedFilters.periodTo,selectedFilters.date,selectedFilters.site_ids)
        .subscribe(
            (res : any) => {
                this.convertSecondsToHMS(res.responseData[0].records.total_time_in_seconds_pdf);
            },
            (error) => {
            }
        );
    }

    downloadPdfClick() {
        const currentPage = localStorage.getItem('currentPage');
        const selectedFilters = JSON.parse(
            localStorage.getItem('selectedFilter') || '{}'
        );
        let isNight = this.checkLocalStorage('isNight');
        let isDay = this.checkLocalStorage('isDay');
        let isDayNight = (isDay && isNight) ? 'both' : isNight ? 'Night' : isDay ? 'Day' : '';
        //MCW and Service Lane in Anomaly Page
        let isShiftServiceLanes = this.checkLocalStorage('isShiftServiceLanes');
        let isShiftMCW = this.checkLocalStorage('isShiftMCW');
        let LaneValue = (isShiftServiceLanes && isShiftMCW) ? 'both' : isShiftServiceLanes ? 'SERVICE_LANE' : isShiftMCW ? 'MCW' : '';
        const currentDate = new Date().toISOString().slice(0, 10); // Get current date in "YYYY-MM-DD" format
         const currentTime = new Date().toLocaleTimeString('en-US', { hour12: false }); // Get current time in "HH:mm:ss" format
         let date = `${currentDate} ${currentTime}`;
        selectedFilters.site_id =
            this.shiftDataService.selectedMasterSite.sub_sites
                .map((site) => site.site_id)
                .toString();
                selectedFilters.date = date;
                 // let site_ids;
        if(selectedFilters.site_id){
            //     site_ids = selectedFilters.site_ids;
                delete selectedFilters.site_id;
            }
        let fileName =
            this.shiftDataService.selectedMasterSite.site_name +
            '-' +
            (this.shiftDataService.isLhs ? 'LHS' : 'RHS') +
            '-' +
            (this.location.includes('shift-data') ? 'shift' : 'master') +
            '-data';
            this.shiftDataService.isUnique = JSON.parse(localStorage.getItem('isUniqueButton'));
            let isShiftDataShoulder = this.checkLocalStorage("isShiftDataShoulder");
            let isShiftDataMedian = this.checkLocalStorage("isShiftDataMedian");
            let isShoulderMedian = (isShiftDataShoulder && isShiftDataMedian) ? '' : (isShiftDataShoulder) ? 'shoulder' : 'median';
        if (currentPage == 'ShiftDataAnalysis') {
            this.dashboardService
                .generateShiftDataPdf(selectedFilters, fileName,this.shiftDataService.isUnique,isDayNight,isShoulderMedian,LaneValue)
                .subscribe(
                    (res) => {
                        // this.replaceSiteIDBySiteIDS(res,selectedFilters,site_ids);
                    },
                    (error) => {
                        // this.replaceSiteIDBySiteIDS(error,selectedFilters,site_ids);
                    }
                );
        } else if (currentPage == 'MasterDataLibrary') {
            this.dashboardService
                .generateMasterDataPdf(selectedFilters, fileName)
                .subscribe(
                    (res) => {
                        // this.replaceSiteIDBySiteIDS(res,selectedFilters,site_ids);
                    },
                    (error) => {
                        // this.replaceSiteIDBySiteIDS(error,selectedFilters,site_ids);
                    }
                );
        }
    }

    convertSecondsToHMS(seconds) {
        const hrs = Math.floor(seconds / 3600);
        const mins = Math.floor((seconds % 3600) / 60);
        const secs = Math.floor(seconds % 60);
        this.estimatedTime = (hrs > 0) ? `${hrs} hr ${mins} min ${secs} sec` : `${mins} min ${secs} sec`;
        this.displayWarningMsg = true;
    }

    replaceSiteIDBySiteIDS(res:any,selectedFilters :any,site_ids:any){
        selectedFilters.site_ids = site_ids;
        delete selectedFilters.site_id;
    }

    private processExportData() {
        return this.shiftDataService.allShiftData.map((asset) => {
            let data = {
                'Asset Name': asset.asset_name,
                Latitude: asset.latitude,
                Longitude: asset.longitude,
                Chainage: asset.Chainage,
                Side:
                    asset.lhs_rhs == 'LHS' || asset.direction == 'Shoulder'
                        ? 'Shoulder'
                        : asset.lhs_rhs == 'RHS' || asset.direction == 'Median'
                        ? 'Median'
                        : 'NA',
            };
            if (!this.isMaster) {
                data['Recent Anomaly'] =
                    asset && asset.recent_anomaly
                        ? this.formatDate(asset.recent_anomaly)
                        : '';
                data['Remarks'] = asset?.remarks || '';
                data['Comments'] = asset?.comment || '';
            }
            return data;
        });
    }

    formatDate(date: any) {
        date = this.datepipe.transform(new Date(date), 'dd-MMM-yyyy');
        return date;
    }
    onDownloadShapefileClick() {
         const currentDate = new Date().toISOString().slice(0, 10); // Get current date in "YYYY-MM-DD" format
         const currentTime = new Date().toLocaleTimeString('en-US', { hour12: false }); // Get current time in "HH:mm:ss" format
         let date = `${currentDate} ${currentTime}`;
        const currentPage = localStorage.getItem('currentPage');
        const selectedFilters = JSON.parse(
            localStorage.getItem('selectedFilter') || '{}'
        );
        let isNight = this.checkLocalStorage('isNight');
        let isDay = this.checkLocalStorage('isDay');
        //MCW and Service Lane in Anomaly Page
        let isShiftServiceLanes = this.checkLocalStorage('isShiftServiceLanes');
        let isShiftMCW = this.checkLocalStorage('isShiftMCW');
        let LaneValue = (isShiftServiceLanes && isShiftMCW) ? 'both' : isShiftServiceLanes ? 'SERVICE_LANE' : isShiftMCW ? 'MCW' : '';
        let isDayNight = (isDay && isNight) ? 'both' : isNight ? 'Night' : isDay ? 'Day' : '';
        selectedFilters.date = date;
        let fileName =
            this.shiftDataService.selectedMasterSite.site_name +
            '-' +
            (this.shiftDataService.isLhs ? 'LHS' : 'RHS') +
            '-' +
            (this.location.includes('shift-data') ? 'shift' : 'master') +
            '-data-Shapefile';
            this.shiftDataService.isUnique = JSON.parse(localStorage.getItem('isUniqueButton'));
        if (currentPage == 'ShiftDataAnalysis') {
            this.dashboardService
                .generateShiftDataShapeFile(selectedFilters, fileName,this.shiftDataService.isUnique,isDayNight,LaneValue)
                .subscribe(
                    (res) => {
                        // this.replaceSiteIDBySiteIDS(res,selectedFilters,site_ids);
                    },
                    (error) => {
                        // this.replaceSiteIDBySiteIDS(error,selectedFilters,site_ids);
                    }
                );
        } else if (currentPage == 'MasterDataLibrary') {
            this.dashboardService
                .generateMasterDataShapeFile(selectedFilters, fileName)
                .subscribe(
                    (res) => {
                        // this.replaceSiteIDBySiteIDS(res,selectedFilters,site_ids);
                    },
                    (error) => {
                        // this.replaceSiteIDBySiteIDS(error,selectedFilters,site_ids);
                    }
                );
        }
        this.alertService.success(
            'Download triggered, it will be downloaded automatically once it is ready.'
            //,{ autoClose: false, keepAfterRouteChange: false }
        );
        this.dialogRef.close();
    }

    closeWindow(){
        this.dialogRef.close();
    }

    getWeeklyReportData(periodDiff : any){
        let site_id:any = [];
        site_id.push(this.shiftDataService.selectedMasterSite.sub_sites[0].site_id);
        site_id.push(this.shiftDataService.selectedMasterSite.sub_sites[1].site_id);
        this.dashboardService.getWeeklyReportData(site_id).subscribe(
          (res: any) => {
            let filePresent = false;
            this.weeklyReportsData = res.responseData[0].records;
            this.weeklyReportsData.forEach((data : any) => {
                if(data.report_date === periodDiff && data.file_type === "xlsx"){
                    filePresent = true;
                    this.dataAlreadyPresent = true;
                    localStorage.setItem('selectedTabIndex',"1");
                    return;
                }
            });
            if(!filePresent){
                this.proceedToDownload();
            }
          },
          (error) => {
            //   this.alertService.error(error.responseStatus.statusDescription);
          }
        );
    }

    redirectReportModule(){
        localStorage.setItem('routeFromDownload', "true");
        const queryParams = { ...this.route.snapshot.queryParams };

        const navigationExtras: NavigationExtras = {
            queryParams,
        }; 
        this.router.navigate(['/reports'],navigationExtras);
        // this.router.navigate(['/reports'],navigationExtras).then(() => {
        //     if (window.location.search) {
        //         this.loc.replaceState(window.location.pathname);
        //     }
        // });
        this.dialogRef.close();
    }

    getMonthlyReportData(periodDiff:any){
        let site_id:any = [];
        site_id.push(this.shiftDataService.selectedMasterSite.sub_sites[0].site_id);
        site_id.push(this.shiftDataService.selectedMasterSite.sub_sites[1].site_id);
        this.dashboardService.getMonthlyReportData(site_id).subscribe(
          (res: any) => {
            this.montlyReportsData = res.responseData[0].records;
            this.montlyReportsData.forEach((data : any) => {
                if(data.report_date === periodDiff){
                    this.dataAlreadyPresent = true;
                    localStorage.setItem('selectedTabIndex',"2");
                    return;
                }
            });
          },
          (error) => {
            //   this.alertService.error(error.responseStatus.statusDescription);
          }
        );
    }

    proceedToDownload(){
        if(this.excelDownload){
            this.downloadExcelClick();
        }else if(this.pdfDownload){
            this.downloadPdfClick();
        }
        this.dialogRef.close();
    }
}
